// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { Resource } from "./resource.js";
export class ExternalTexture extends Resource {
    static defaultProps = {
        ...Resource.defaultProps,
        source: undefined,
        colorSpace: 'srgb'
    };
    get [Symbol.toStringTag]() {
        return 'ExternalTexture';
    }
    constructor(device, props) {
        super(device, props, ExternalTexture.defaultProps);
    }
}
//# sourceMappingURL=external-texture.js.map